import { useMutation, gql } from "@apollo/client";

export const ADD_USER_DOCUMENT = gql`
  mutation useAddUserDocument($input: AddUserDocumentInput!) {
    addUserDocument(input: $input) {
      document {
        id
        url
      }
    }
  }
`;

export default (options) => {
  return useMutation(ADD_USER_DOCUMENT, options);
};
